<simple-notifications></simple-notifications>
<ngx-spinner></ngx-spinner>
<div bsModal #cashflowModel="bs-modal" class="modal fade custom-modal" tabindex="-1"
     [config]="{ backdrop: 'static' ,ignoreBackdropClick: true}" role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header pb-1">
        <h4 class="modal-title pull-left">List by Cash Flow</h4>
        <button type="button" class="close pull-right"
                (click)="closeModel()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="form" [formGroup]="cashflowListForm" novalidate>
          <table class="table table-responsive">
            <thead>
            <tr>
              <th width="30%">Address</th>
              <th width="25%">Property Type</th>
              <th width="15%">Monthly Mortgage </th>
              <th width="15%">Monthly Rent </th>
              <th width="15%" class="text-right">Monthly Cashflow</th>
            </tr>
            </thead>
            <tbody>
            <ng-container formArrayName="cashflowList">
              <tr *ngFor="let control of addCashflowList.controls; let index = index" [formGroupName]='index'>
                <td>{{control.get('property_address').value}}</td>
                <td>{{control.get('property_type').value}}</td>
                <td>
                  <div class="position-relative mb-0 reduce-width">
                    <label class="form-group has-float-label has-left-icon-append">
                      <div class="input-group">
                        <div class="input-group-prepend custom-input-group-append-icon-right-border">
                          <span class="input-group-text custom-input-group-append-icon ">$</span>
                        </div>
                        <input type="number" class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm" formControlName="monthly_repayment"
                               name="monthly_repayment" (blur)="changeValue(index)" [readonly]="control.get('is_mortgage_disable').value">
                      </div>
                    </label>
                  </div>
                </td>
                <td>
                  <label class="form-group has-float-label has-left-icon-append">
                    <div class="input-group">
                      <div class="input-group-prepend custom-input-group-append-icon-right-border">
                        <span class="input-group-text custom-input-group-append-icon ">$</span>
                      </div>
                      <input type="number" class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm" formControlName="rent_per_month"
                             name="rent_per_month" (blur)="changeValue(index)">
                    </div>
                  </label>
                </td>
                <td class="text-right">{{control.get('cash_flow').value | number:'1.2-2'}}</td>
              </tr>
            </ng-container>
            </tbody>
          </table>
          <table class="table mb-0">
            <tbody>
            <tr>
              <td width="30%" class="font-weight-bold">Total</td>
              <td width="25%"></td>
              <td width="15%" >{{cashflowListForm.get('total_monthly_repayment').value | currency}}</td>
              <td width="15%" >{{cashflowListForm.get('total_rent_per_month').value | currency}}</td>
              <td width="15%" class="text-right">{{cashflowListForm.get('total_cash_flow').value | currency}}</td>
            </tr>
            </tbody>
          </table>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-xs custom-btn-sec"
                (click)="closeModel()">Close</button>
        <app-state-button btnClass="btn btn-primary btn-xs custom-btn-primary" [currentState]="responseWaiting" message="false"
                          (click)="cashflowSubmit()" [isDisabled]="buttonDisabled">Save
        </app-state-button>
      </div>
    </div>
  </div>
</div>
